// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Minoxidil / Finasteride /Biotin    (Men & Women) 09.17.26" (390e3648-3f19-450c-8d84-737d12327a18). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiMinoxidilFinasterideBiotinMenWomenQuestions = [
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_wereSorryDueEitherBeing',
    label:
      "We're sorry, due to either being pregnant, trying to conceive, or current breastfeeding, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '51fa2f62-a7c7-49b5-9ecb-27fdcfc54f6b',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_tryingConceivePlanConceivingNear',
    label:
      'Are you currently trying to conceive or plan on conceiving in the near future?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'ed1af744-b23a-47a4-9074-b4bdce0e889e' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_wereSorryBasedPreviousResponse',
    label:
      "We're sorry, based on your previous response, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '84a94cf2-89b8-40f3-bbc4-2a6bbb1b8c24',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_requiredAcknowledgmentUnderstandFormulationContains',
    label:
      'Required Acknowledgment: I understand this formulation contains Finasteride, which may pose risks during pregnancy and must not be used if pregnant or attempting conception.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'i_agree', value: 'I agree' }]
    },
    extras: { mdiQuestionId: '684a3a64-fbf6-470b-bebc-6ad83acc5b84' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_primaryConcern',
    label: 'What is your primary concern?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hair_thinning', value: 'Hair thinning' },
        { key: 'receding_hairline', value: 'Receding hairline' },
        { key: 'bald_spots', value: 'Bald spots' },
        { key: 'excess_shedding', value: 'Excess shedding' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: 'dded7181-f2af-42e1-a3fd-a4b6089e099d' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_didFirstNoticeHairLoss',
    label: 'When did you first notice hair loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_6_months_ago', value: 'Less than 6 months ago' },
        { key: 'o_6_12_months_ago', value: '6-12 months ago' },
        { key: 'o_1_3_years_ago', value: '1-3 years ago' },
        { key: 'longer_than_3_years_ago', value: 'Longer than 3 years ago' }
      ]
    },
    extras: { mdiQuestionId: 'd2376bd0-b645-4fdc-ae87-dbec8ff86cc5' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_whereHairLossOccurring',
    label: 'Where is the hair loss occurring?',
    type: 'select',
    educationalSlide: '(Select all that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'crown', value: 'Crown' },
        { key: 'temples', value: 'Temples' },
        { key: 'entire_scalp', value: 'Entire scalp' },
        { key: 'patchy_areas', value: 'Patchy areas' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: 'e914c4d0-f6f1-47bd-9af0-cce31929e764' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_hairLoss',
    label: 'Has your hair loss:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'stayed_the_same', value: 'Stayed the same' },
        { key: 'gradually_worsened', value: 'Gradually worsened' },
        { key: 'rapidly_worsened', value: 'Rapidly worsened' }
      ]
    },
    extras: { mdiQuestionId: '6f80a069-4ef9-4261-89b9-b53d8048ca92' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_familyHistoryHairLoss',
    label: 'Do you have a family history of hair loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' },
        { key: 'unsure', value: 'Unsure' }
      ]
    },
    extras: { mdiQuestionId: '31814225-dcc2-4be7-a1f2-0d5eedd20ff3' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_conditions',
    label: 'Do you have any of the following conditions?',
    type: 'select',
    educationalSlide: '(Select all that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'liver_disease', value: 'Liver disease' },
        {
          key: 'hormonal_disorders_e_g_pcos_thyroid_issu',
          value: 'Hormonal disorders (e.g., PCOS, thyroid issues)'
        },
        {
          key: 'scalp_conditions_eczema_psoriasis_infect',
          value: 'Scalp conditions (eczema, psoriasis, infections)'
        },
        {
          key: 'anemia_or_nutrient_deficiency',
          value: 'Anemia or nutrient deficiency'
        },
        {
          key: 'skin_conditions_eczema_psoriasis_dermati',
          value: 'Skin conditions (eczema, psoriasis, dermatitis)'
        },
        { key: 'prostate_conditions', value: 'Prostate conditions' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '739e79ca-974a-40c1-b973-a73e05315b69' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_everDiagnosed',
    label: 'Have you ever been diagnosed with any of the following?',
    type: 'select',
    educationalSlide: '(select any that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'androgenetic_alopecia', value: 'Androgenetic alopecia' },
        { key: 'alopecia_areata', value: 'Alopecia areata' },
        { key: 'telogen_effluvium', value: 'Telogen effluvium' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'ca556a40-3c5a-4ea8-9ff6-3286f1362ff2' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding',
    label:
      'Can you provide your doctor with more insight regarding your diagnosis?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding',
      rows: 4
    },
    extras: { mdiQuestionId: '7ad6fff3-4405-4fbd-acc2-d5b795166249' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_usingHairLossTreatmentsIncludes',
    label:
      'Are you currently using any hair loss treatments? This includes any oral or topical products.',
    type: 'select',
    educationalSlide:
      'If yes, please list what treatments you are currently using.',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '96554a3c-37fe-439c-9ce5-1c4dbe78b61f' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_youuseProducts',
    label: 'Have youuse any of the following products?',
    type: 'select',
    educationalSlide:
      'Select those that apply, then further explain your experience.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'minoxidil',
          value: 'Minoxidil',
          answer: {
            type: 'text',
            name: 'minoxidil_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'retinoids_e_g_tretinoin',
          value: 'Retinoids (e.g., tretinoin)',
          answer: {
            type: 'text',
            name: 'retinoids_e_g_tretinoin_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'alcohol_based_topicals',
          value: 'Alcohol-based topicals',
          answer: {
            type: 'text',
            name: 'alcohol_based_topicals_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'finasteride', value: 'Finasteride' },
        { key: 'dutasteride', value: 'Dutasteride' },
        { key: 'ketoconazole_shampoo', value: 'Ketoconazole shampoo' },
        { key: 'microneedling', value: 'Microneedling' },
        { key: 'prp', value: 'PRP' },
        {
          key: 'i_have_not_tried_any_of_the_above_produc',
          value: 'I have NOT tried any of the above products'
        }
      ]
    },
    extras: { mdiQuestionId: '952e8b7d-e063-440b-90c9-59b4a34a18b7' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried',
    label: 'How was your experience with the products you tried?',
    type: 'info',
    subLabel: 'Did you have any side effects?  Did you notice improvement?',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried',
      rows: 4
    },
    extras: { mdiQuestionId: '1def382f-b703-4b82-bfc1-5c9d2bca7953' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_scalpIrritationOpenWoundsInfection',
    label: 'Do you have scalp irritation, open wounds, or infection?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '6e806c6c-2c1a-4130-a54b-69c0e95b4328' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_redness',
    label: 'Do you currently have:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'redness', value: 'Redness' },
        { key: 'flaking', value: 'Flaking' },
        { key: 'itching', value: 'Itching' },
        { key: 'burning', value: 'Burning' },
        { key: 'none', value: 'None' }
      ]
    },
    extras: { mdiQuestionId: '4766dbcd-067c-41fb-bb43-384218aa7628' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_history',
    label: 'Do you have a history of',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'eczema', value: 'Eczema' },
        { key: 'seborrheic_dermatitis', value: 'Seborrheic dermatitis' },
        { key: 'psoriasis', value: 'Psoriasis' },
        { key: 'contact_dermatitis', value: 'Contact dermatitis' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'c4a77908-e28f-4a5e-9d74-586de7fe4912' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_usingScalp',
    label: 'Are you currently using any of the following on your scalp?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'exfoliating_acids_salicylic_glycolic_lac',
          value: 'Exfoliating acids (salicylic, glycolic, lactic)'
        },
        { key: 'medicated_shampoos', value: 'Medicated shampoos' },
        { key: 'topical_steroids', value: 'Topical steroids' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'f38cbeb2-ae83-4b91-914a-a5935fa849c4' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_historyLowBloodPressureDizziness',
    label: 'Do you have a history of low blood pressure or dizziness?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'f8c723e9-2ae6-43c5-8de2-0a4b44a470c9' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_experiencedDecreasedLibidoLately',
    label: 'Have you experienced decreased libido lately?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'd8237e3d-6e2c-4097-a847-7959b9dbba3a' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_experienced',
    label: 'Have you experienced any of the following?',
    type: 'select',
    educationalSlide: '(select those that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'decreased_libido', value: 'Decreased libido' },
        { key: 'erectile_dysfunction', value: 'Erectile dysfunction' },
        { key: 'ejaculatory_issues', value: 'Ejaculatory issues' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'f7b46a17-50b5-4539-95e0-9aedd567c1c1' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_fertilityConcerns',
    label: 'Have you had any fertility concerns?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '38830cb3-73b4-46c9-b4d0-7706f8e573fd' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding2',
    label:
      'Can you please provide your doctor with more insight regarding your fertility concerns?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding2',
      rows: 4
    },
    extras: { mdiQuestionId: '01224f2c-a130-42b0-91ef-9cad689c359c' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_historyDepressionAnxietyMoodDisorders',
    label: 'Do you have a history of depression, anxiety, or mood disorders?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '144a19cc-37a9-4ded-acb5-0fa5c7f2d126' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorFurtherInsightHistory',
    label:
      'Can you please provide your doctor with further insight to your history ofdepression, anxiety, or mood disorders?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorFurtherInsightHistory',
      rows: 4
    },
    extras: { mdiQuestionId: '33ffd778-66e2-4851-8308-0a38a1b8f073' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_history2',
    label: 'Do you have a history of any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'suicidal_thoughts', value: 'Suicidal thoughts' },
        { key: 'severe_depression', value: 'Severe depression' },
        {
          key: 'neither_of_these_apply_to_me',
          value: 'Neither of these apply to me'
        }
      ]
    },
    extras: { mdiQuestionId: 'be1e082b-0eca-40e2-8bb8-f5fe24990db8' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_ever',
    label: 'Have you ever had any of the following:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'elevated_psa_levels', value: 'Elevated PSA levels' },
        { key: 'prostate_issues', value: 'Prostate issues' },
        { key: 'prostate_cancer', value: 'Prostate cancer' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'dda434bf-7c0b-465b-82c3-695af228fcff' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_rateStressLevelDailyBasis',
    label: 'How would you rate your stress level on a daily basis?',
    type: 'info',
    subLabel: '0: No stress 10: I am constantly experiencing stress',
    answer: {
      type: 'number',
      name: 'mdiMinoxidilFinasterideBiotinMenWomen_rateStressLevelDailyBasis'
    },
    extras: { mdiQuestionId: 'caa7ef13-0f50-477a-89eb-b99eb5375db3' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_experiencedRecentMajorStressIllness',
    label:
      'Have you experienced a recent major stress, illness, or weight loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'f4e2ab76-2999-4a87-8f68-3554e28ce6bd' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRecent',
    label:
      'Can you provide your doctor with more insight to your recent major stress, illness, or weight loss:',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRecent',
      rows: 4
    },
    extras: { mdiQuestionId: 'a3ec0ce1-aed0-4813-b3ee-593e70ab2d9d' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_uploadClearWellLitPhoto',
    label: 'Please upload a clear, well-lit photo of the affected area:',
    type: 'file_upload',
    accepts: [
      'image/jpeg',
      'image/jpg',
      'image/webp',
      'image/png',
      'application/pdf'
    ],
    answer: [
      {
        resourceId:
          'mdiMinoxidilFinasterideBiotinMenWomen_uploadClearWellLitPhoto',
        buttonLabel: 'Upload'
      }
    ],
    extras: { mdiQuestionId: 'db866d68-6a97-42ed-bafc-5ec17825239a' }
  },
  {
    field:
      'mdiMinoxidilFinasterideBiotinMenWomen_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent  (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideBiotinMenWomen_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: '4115f9f2-5c34-41f3-a265-597710774e05' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideBiotinMenWomen_firstMessageDoctor',
      rows: 4
    },
    extras: { mdiQuestionId: 'd800126b-7d9d-462a-b681-52680169744c' }
  },
  {
    field: 'mdiMinoxidilFinasterideBiotinMenWomen_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiMinoxidilFinasterideBiotinMenWomenAnswerField = Partial<
  QuestionAnswerMap<typeof mdiMinoxidilFinasterideBiotinMenWomenQuestions>
>;

export default mdiMinoxidilFinasterideBiotinMenWomenQuestions;
